import * as React from 'react';
import Axios, { AxiosResponse } from 'axios';
import { IMedia, ITag, IPagination } from '../interfaces';
import config from '../config';
import Pagination from '../components/common/Pagination';
import { withTranslation } from 'react-i18next';
import Banner from '../components/parts/Banner';
import Helmet from 'react-helmet';
import { NavLink } from 'react-router-dom';

const CancelToken = Axios.CancelToken;
let cancel: any;

interface IState {
    isLoading: boolean,
    channels: any[],
    blocks: any[],
    channel: any,
    vast: any,
    tags: any[],
    tag_id: number,
    currentPage: number,
    totalPages: number,
    pages: IPagination,

    options: any
}

class TvView extends React.Component<any, IState>{
    private _isUnmounted: boolean = false;
    private player: any;
    private videoNode: any;

    constructor(props: any) {
        super(props);

        this.state = {
            isLoading: true,
            channels: [],
            blocks: [],
            channel: null,
            vast: null,
            tag_id: null,
            tags: [],
            currentPage: 1,
            totalPages: 1,
            pages: null,

            options: {
                loop: false,
                margin: 30,
                nav: true,
                autoHeight: true,
                responsive: {
                    0: {
                        items: 2
                    },
                    400: {
                        items: 2
                    },
                    600: {
                        items: 2
                    },
                    800: {
                        items: 3
                    },
                    1000: {
                        items: 5
                    }
                },
            },
        };
    }

    async componentDidMount() {
        await this.loadBlocks();
        await this.loadTags();
        await this.loadChannels();
    }

    componentWillUnmount() {
        this._isUnmounted = true;

        if (this.player) {
            this.player.dispose()
        }
    }

    componentWillReceiveProps(nextProps: any) {
        if (this.player) {
            this.player.dispose()
        }

        this.setState({
            channel: null,
            isLoading: true
        }, () => {
            this.setState({
                channel: this.state.channels.find((channel: any) => channel.id == this.props.match.params.id),
                isLoading: false
            }, () => {
                this.initPlayer();
            });
        });
    }

    initPlayer() {

        if (this.state.channel) {
            // @ts-ignore
            this.player = window.videojs(this.videoNode, this.state.vast ? {
                aspectRatio: '16:9',
                fill: true,
                fluid: true,
                "plugins": {
                    "vastClient": {
                        "adCancelTimeout": 20000,// Wait for ten seconds before canceling the ad.
                        "adsEnabled": true,
                        "adTagUrl": `https://${window.location.host}/api/default/vast?category_id=36`
                    }
                }
            } : {
                aspectRatio: '16:9',
                fill: true,
                fluid: true
            });

            this.player.on('loadedmetadata', function () {
                if (this.player.qualityLevels) {
                    for (var i = 0; i < this.player.qualityLevels().length; i++) {
                        if (this.player.qualityLevels()[i].width >= 720) {
                            this.player.qualityLevels()[i].enabled = true;
                        } else {
                            this.player.qualityLevels()[i].enabled = false;
                        }
                    }
                }
            });

            if (this.player.qualityPickerPlugin)
                this.player.qualityPickerPlugin();

            this.player.ready(function () {
                this.hotkeys({
                    volumeStep: 0.1,
                    seekStep: 10,
                    enableMute: true,
                    enableFullscreen: true,
                    enableNumbers: false,
                    enableVolumeScroll: true,
                    enableHoverScroll: true,

                    // Mimic VLC seek behavior, and default to 5.
                    // @ts-ignore
                    seekStep: function (e: any) {
                        if (e.ctrlKey && e.altKey) {
                            return 5 * 60;
                        } else if (e.ctrlKey) {
                            return 60;
                        } else if (e.altKey) {
                            return 10;
                        } else {
                            return 5;
                        }
                    },

                    // Enhance existing simple hotkey with a complex hotkey
                    fullscreenKey: function (e: any) {
                        // fullscreen with the F key or Ctrl+Enter
                        return ((e.which === 70) || (e.ctrlKey && e.which === 13));
                    },

                });
            });

            this.player.landscapeFullscreen();

            this.player.play();
        }
    }

    async loadChannels() {
        cancel && cancel();

        this.setState({
            isLoading: true,
            channels: [],
            channel: null
        }, async () => {
            try {
                let response: AxiosResponse = await Axios.get(`https://api.new.mediabox.uz/v2/tv/channels?per-page=100`, {
                    cancelToken: new CancelToken(function executor(c) {
                        cancel = c;
                    })
                });

                let { data } = response;

                if (!this._isUnmounted) {
                    this.setState({
                        channels: data.data,
                        channel: data.data.find((channel: any) => channel.id == this.props.match.params.id),
                        isLoading: false,
                    }, () => {
                        $('#carusel144').owlCarousel("destroy");
                        $('#carusel144').owlCarousel(this.state.options);

                        $(window).ready(function () {
                            setTimeout(function () {
                                $('.owl-carousel').trigger('refresh.owl.carousel');
                            }, 50);
                        });

                        this.initPlayer();
                    });
                }
            } catch (err) {

            }
        })
    }

    async loadTags() {
        let response: AxiosResponse = await Axios.get(`https://api.new.mediabox.uz/v2/tv/categories?per-page=100`);

        if (!this._isUnmounted)
            this.setState({
                tags: response.data.data
            });
    }


    async loadBlocks() {
        cancel && cancel();

        try {
            let response: AxiosResponse = await Axios.get(`${config.host}/default/blocks?category_id=36`, {
                cancelToken: new CancelToken(function executor(c) {
                    cancel = c;
                })
            });

            let { data } = response;

            if (!this._isUnmounted) {
                this.setState({
                    blocks: data.blocks,
                    vast: data.vast,
                });
            }
        } catch (err) {

        }
    }

    onTagChange(tag_id: number) {
        this.setState({
            tag_id,
            isLoading: true,
        }, this.loadChannels);
    }

    render() {
        const { t } = this.props;

        return (
            <div className="i-body">
                <Helmet>
                    <title>{t("Онлайн ТВ") + " | " + window.location.host.toUpperCase() + " - Медиа портал в TAS-IX"}</title>
                </Helmet>
                <div className="container login-page v-index">
                    <div className="wrapper">
                        <div className="wrap games watch">
                            <div className="fast_link p-0 m-0">
                                <div className="title mt-0" style={{ color: "#080f22", fontSize: "30px" }}>
                                    {this.state.channel ? this.state.channel.title : t("Онлайн ТВ")}
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-12">
                                    {!this.state.isLoading && this.state.channel && <div data-vjs-player className="w-100">
                                        <video ref={node => this.videoNode = node} controls className="video-js vjs-default-skin w-100 object-fit-fill" data-setup='{}' poster={this.state.channel.image}>
                                            <source src={this.state.channel.tv_link} type="application/x-mpegURL" />
                                            <p>Video Playback Not Supported</p>
                                        </video>
                                    </div>}
                                </div>
                            </div>

                        </div>
                        <div className="inner-trailer">
                            <div className="films">
                                <nav>
                                    <div>
                                        <NavLink to="/tv" activeClassName="no" className="film"> {t("Другие каналы")} </NavLink>
                                    </div>
                                    <div>
                                        <NavLink to="/tv" activeClassName="no">
                                            {t("Все каналы")}
                                        </NavLink>
                                    </div>
                                </nav>
                                <div className="owl-carousel box_list " id="carusel144">
                                    {this.state.channels.filter((channel: any) => channel.category_id == this.state.tag_id || this.state.tag_id == null).filter((channel: any) => this.state.blocks.indexOf(channel.id) == -1).filter((channel: any) => channel.id != this.props.match.params.id).map((channel: any, index: number) => {
                                        return (
                                            <div key={index} className="item">
                                                <div className="img img_box tv_img_box">
                                                    <NavLink to={"/tv/" + channel.id} style={{ display: 'block', height: "100%", width: "100%" }}>
                                                        <img style={{ width: "100%", height: "100%!important" }} src={"https://" + window.location.host + "/uploads/tv/" + channel.id + ".jpg"} alt={channel.title} />
                                                    </NavLink>
                                                    <div className="icons">
                                                        <ul>
                                                            <li>
                                                            </li>
                                                            <li className="transform">
                                                                <NavLink className="scroll-to-top" to={`/tv/${channel.id}`}>
                                                                    <i className="fa fa-play-circle-o"></i>
                                                                </NavLink>
                                                            </li>
                                                            <li className="btn-group share-box">

                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                                <h1 className="text-center"><NavLink to={"/tv/" + channel.id}>{channel.title}</NavLink></h1>
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>
                        </div>

                        <Banner className="banner235" place={46} />

                    </div>
                </div>
            </div>
        );
    }
}

export default withTranslation()(TvView);